import { render, staticRenderFns } from "./PwaNewContent.vue?vue&type=template&id=3bdea776&scoped=true&"
import script from "./PwaNewContent.vue?vue&type=script&lang=ts&"
export * from "./PwaNewContent.vue?vue&type=script&lang=ts&"
import style0 from "./PwaNewContent.vue?vue&type=style&index=0&id=3bdea776&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bdea776",
  null
  
)

/* custom blocks */
import block0 from "./PwaNewContent.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports